import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact section" id="contact">
      <span className="section_subtitle">Get Connected</span>
      <h2 className="section_title">Let's Talk </h2>

      <div className="contact_container ">
        <div className="contact_content">
          <h3 className="contact_title">I am available for your project</h3>

          <div className="contact_info grid grid-cols-1 m-6 lg:grid-cols-4">
            <div className="contact_card bg-gray-100 text-gray-800">
              <i className="uil uil-envelopes contact_card-icon text-blue-500"></i>
              <h3 className="contact_card-title">Email</h3>
              <span className="contact_card-data">sakibsaizeed@gmail.com</span>
              <a
                href="mailto:sakibsaizeed@gmail.com"
                className="contact_button bg-blue-500 hover:bg-blue-600"
              >
                <p>Mail Now</p>
              </a>
            </div>
            <div className="contact_card bg-gray-100 text-gray-800">
              <i className="uil uil-whatsapp contact_card-icon text-green-500"></i>
              <h3 className="contact_card-title">WhatsApp</h3>
              <span className="contact_card-data">+88-01689279260</span>
              <a
                href="https://wa.me/+8801689279260"
                className="contact_button bg-green-500 hover:bg-green-600"
              >
                <p>Text Now</p>
              </a>
            </div>
            <div className="contact_card bg-gray-100 text-gray-800">
              <i className="uil uil-skype contact_card-icon text-blue-500"></i>
              <h3 className="contact_card-title">Skype</h3>
              <span className="contact_card-data">live:sakibsaizeed</span>
              <a
                href="https://join.skype.com/invite/ywqXniwX4NV4"
                className="contact_button bg-blue-500 hover:bg-blue-600"
              >
                <p>Skype Now</p>
              </a>
            </div>
            <div className="contact_card bg-gray-100 text-gray-800">
              <i className="uil uil-phone contact_card-icon text-yellow-500"></i>
              <h3 className="contact_card-title">Phone</h3>
              <span className="contact_card-data">+8801735005354</span>
              <a
                href="tel:+8801735005354"
                className="contact_button bg-yellow-500 hover:bg-yellow-600"
              >
                <p>Call Now</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
